/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import firebase from 'firebase';
import axios from '@/axios.js'
import con from '@/firebase/firebaseInit.ts'
import ls from "@/common/localStorage"
import moment from "moment-timezone";

//const cn = 'OA_UAT_C1591205467009E1591206650065'
var cn = ls.getSessionEventCollectionName();
var mailtplRef;
if (ls.getSessionValueByKey("Role") == 1) {
    mailtplRef = con.instanceDB.doc('mailtpl');
} else {
    var mailtplRef = con.eventDB.collection(cn).doc('mailtpl');
}
const mailtplRefInstnc = con.instanceDB.doc('mailtpl');
const storageRef = con.storageRef;
let MailactivityApi = con.MailactivityApi
let MailactivityApiKey = con.MailactivityApiKey
let GetsubcollectionsApi = con.GetsubcollectionsApi

var Session_Event_FullName = ls.getSessionValueByKey("Session_Event_FullName");
var Sesion_EventAccessType = ls.getSessionValueByKey("Sesion_EventAccessType");

export default {
    fetchMenus({ commit }) {
        return new Promise((resolve, reject) => {
            con.instanceDB.doc('Menu').get().then(function (doc) {
                commit('SET_MENU', doc.data().AllMenu)
                resolve(doc.data().AllMenu);

            })
        })
    },
    changeStatus(context, field) {
        return new Promise((resolve, reject) => {
            var allMenus = [];
            con.instanceDB.doc('Menu').get().then(function (doc) {
                allMenus = doc.data().AllMenu;
                if (field.data.length == 1) {
                    for (var i = 0; i < allMenus.length; i++) {
                        if (allMenus[i].MenuID == field.data[0].MenuID) {
                            allMenus[i].IsPublished = field.data[0].IsPublished;
                        }
                    }
                    con.instanceDB.doc('Menu').update({
                        AllMenu: allMenus
                    }).then(function () {
                        resolve({ status: 200, message: "Menu Updated" });
                    });
                }
            });
        });
    },
    fetchFeatures({ commit }) {
        return new Promise((resolve, reject) => {
            con.instanceDB.doc('Features').get().then(function (doc) {
                resolve(doc.data().Features);
            })
        })
    },
    uploadImage(context, field) {
        return new Promise((resolve, reject) => {
            if (field.file && field.path) {
                let path = field.path;
                let file = field.file
                let metadata = {
                    'contentType': file.type
                }
                storageRef.child(path + (new Date().getTime()) + "_" + file.name).put(file, metadata).then(function (snapshot) {
                    snapshot.ref.getDownloadURL().then(function (url) {
                        resolve(url.toString())
                    })
                })
            } else {
                resolve('')
            }
        })
    },
    getHighestMenuId({ commit }) {
        return new Promise((resolve, reject) => {
            var allMenusIds = [];
            con.instanceDB.doc('Menu').get().then(function (doc) {
                doc.data().AllMenu.map((menu) => {
                    allMenusIds.push(parseInt(menu.MenuID));
                });
                resolve(Math.max(...allMenusIds));
            })
        })
    },
    addOrUpdateMenu(context, field) {
        return new Promise((resolve, reject) => {
            var allMenus = [];
            con.instanceDB.doc('Menu').get().then(function (doc) {
                allMenus = doc.data().AllMenu;
                allMenus[allMenus.length] = field.data;
                con.instanceDB.doc('Menu').update({
                    AllMenu: allMenus
                }).then(function () {
                    resolve({ status: 200, message: "Menu Added Succesfully" });
                });
            });
        })
    },
    addNewFeature(context, field) { 
        return new Promise((resolve, reject) => {
            var allFeatures = [];
            var allFeatureIds = [];
            con.instanceDB.doc('Features').get().then(function (doc) {
                allFeatures = doc.data().Features;
                
                allFeatures.map((feature) => {
                    allFeatureIds.push(parseInt(feature.ID));
                });

                field.ID = Math.max(...allFeatureIds) + 1

                allFeatures[allFeatures.length] = field;
                con.instanceDB.doc('Features').update({
                    Features: allFeatures
                }).then(function () {
                    resolve({ status: 200, message: "Feature Added Succesfully" });
                });

            });
        });
    },
}